import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-outgoing-call-icon',
  templateUrl: './communication-outgoing-call.component.html'
})
export class CommunicationOutgoingCallComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
